import { render, staticRenderFns } from "./IntrestedPartnersList.vue?vue&type=template&id=37e5bc31&scoped=true&"
import script from "./IntrestedPartnersList.vue?vue&type=script&lang=js&"
export * from "./IntrestedPartnersList.vue?vue&type=script&lang=js&"
import style0 from "./IntrestedPartnersList.vue?vue&type=style&index=0&id=37e5bc31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5bc31",
  null
  
)

export default component.exports